<template>
  <section class="admin-content" id="contact-search">
    <main class="admin-main" style="background:#f8fafc; min-height:100vh;">

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>

      <!-- Page Header -->
      <div style="background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%); padding: 32px 0;">
        <div class="container text-center text-white">
          <div class="mb-2" style="width:56px;height:56px;background:rgba(255,255,255,.18);border-radius:14px;display:flex;align-items:center;justify-content:center;margin:0 auto 12px;">
            <i class="fe fe-star" style="font-size:22px;"></i>
          </div>
          <h4 class="font-weight-bold mb-1">Rate Your Experience</h4>
          <p class="mb-0" style="opacity:.8;font-size:.9rem;">
            <span v-if="encounterDetails.provider && encounterDetails.provider.agency_name">
              at {{ encounterDetails.provider.agency_name }}
            </span>
          </p>
        </div>
      </div>

      <div class="container py-4" style="max-width: 860px;">
        <div class="row" id="printDiv" ref="printNow">

          <!-- Enrollee Info Column -->
          <div class="col-md-4 mb-4">
            <div class="card table-card shadow h-100">
              <div class="form-card-header">
                <div class="section-number"><i class="fe fe-user" style="font-size:13px;"></i></div>
                <div>
                  <p class="mb-0 text-white font-weight-bold" style="font-size:.88rem;">Enrollee</p>
                </div>
              </div>
              <div class="card-body text-center pt-3">
                <img
                  :src="`https://claimify-api.hayokmedicare.ng/image/${encounterDetails.enrollee && encounterDetails.enrollee.user_image}`"
                  alt="Enrollee Image"
                  class="rounded-circle mb-3"
                  style="width:80px;height:80px;object-fit:cover;border:3px solid #e2e8f0;"
                  onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'"
                />
                <p class="font-weight-bold mb-1">
                  {{ encounterDetails.enrollee && encounterDetails.enrollee.lastname }}
                  {{ encounterDetails.enrollee && encounterDetails.enrollee.firstname }}
                </p>
                <span v-if="encounterDetails.is_confirmed == true">
                  <span class="badge badge-soft-success" style="font-size:.75rem;">Confirmed</span>
                </span>
                <span v-if="encounterDetails.is_confirmed == false">
                  <span class="badge badge-soft-danger" style="font-size:.75rem;">Rejected</span>
                </span>
              </div>
              <ul class="list-unstyled mb-0">
                <li class="info-row">
                  <i class="fe fe-credit-card info-icon"></i>
                  <div>
                    <p class="info-label">Enrollee ID</p>
                    <p class="info-value"><span class="code-chip">{{ encounterDetails.enrollee && encounterDetails.enrollee.id_card_number }}</span></p>
                  </div>
                </li>
                <li class="info-row">
                  <i class="fe fe-phone info-icon"></i>
                  <div>
                    <p class="info-label">Phone</p>
                    <p class="info-value">{{ encounterDetails.enrollee && encounterDetails.enrollee.phone_number }}</p>
                  </div>
                </li>
                <li class="info-row">
                  <i class="fe fe-calendar info-icon"></i>
                  <div>
                    <p class="info-label">Date of Birth</p>
                    <p class="info-value">{{ encounterDetails.enrollee && encounterDetails.enrollee.dob }}</p>
                  </div>
                </li>
                <li class="info-row">
                  <i class="fe fe-user info-icon"></i>
                  <div>
                    <p class="info-label">Gender</p>
                    <p class="info-value">{{ encounterDetails.enrollee && encounterDetails.enrollee.gender }}</p>
                  </div>
                </li>
                <li class="info-row">
                  <i class="fe fe-grid info-icon"></i>
                  <div>
                    <p class="info-label">Sector</p>
                    <p class="info-value">{{ encounterDetails.enrollee && encounterDetails.enrollee.sector }}</p>
                  </div>
                </li>
                <li class="info-row">
                  <i class="fe fe-activity info-icon"></i>
                  <div>
                    <p class="info-label">Facility</p>
                    <p class="info-value">{{ encounterDetails.provider && encounterDetails.provider.agency_name }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <!-- Treatment + Review Column -->
          <div class="col-md-8 mb-4">

            <!-- Treatment Details Card -->
            <div class="card table-card shadow mb-4" v-if="encounterDetails.services">
              <div class="d-flex align-items-center px-4 pt-4 pb-3">
                <i class="fe fe-clipboard text-primary mr-2"></i>
                <h6 class="mb-0 font-weight-bold">Treatment Details</h6>
              </div>
              <ul class="list-unstyled mb-0">
                <li class="info-row" v-if="encounterDetails.diagnosis != null">
                  <i class="fe fe-thermometer info-icon"></i>
                  <div>
                    <p class="info-label">Treatment For</p>
                    <p class="info-value">{{ encounterDetails.diagnosis.name }}</p>
                  </div>
                </li>
                <li class="info-row">
                  <i class="fe fe-file-text info-icon"></i>
                  <div>
                    <p class="info-label">Investigations</p>
                    <p class="info-value">{{ encounterDetails.healthrecord && encounterDetails.healthrecord.testResult }}</p>
                  </div>
                </li>
                <li class="info-row">
                  <i class="fe fe-message-square info-icon"></i>
                  <div>
                    <p class="info-label">Consultation Note</p>
                    <p class="info-value">{{ encounterDetails.healthrecord && encounterDetails.healthrecord.notes }}</p>
                  </div>
                </li>
                <li class="info-row">
                  <i class="fe fe-clock info-icon"></i>
                  <div>
                    <p class="info-label">Date & Time of Visit</p>
                    <p class="info-value">{{ encounterDetails.healthrecord && encounterDetails.healthrecord.date_of_visit }}</p>
                  </div>
                </li>
              </ul>
              <div class="card-body pt-2" v-if="encounterDetails.is_confirmed == null">
                <div class="d-flex" style="gap:8px;">
                  <button @click="updateEncounterStatus(encounterDetails, true)"
                    type="button" class="btn btn-outline-success">
                    <i class="fe fe-check mr-1"></i> I received this treatment
                  </button>
                  <button @click="updateEncounterStatus(encounterDetails, false)"
                    type="button" class="btn btn-outline-danger">
                    <i class="fe fe-x mr-1"></i> I did not receive this treatment
                  </button>
                </div>
              </div>
            </div>

            <!-- Submit Review Card -->
            <div class="card table-card shadow" v-if="encounterDetails.review == null && encounterDetails.is_confirmed == true">
              <div class="form-card-header">
                <div class="section-number"><i class="fe fe-star" style="font-size:13px;"></i></div>
                <div>
                  <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Leave a Review</p>
                  <small style="color:rgba(255,255,255,.7);">Share your experience at {{ encounterDetails.provider && encounterDetails.provider.agency_name }}</small>
                </div>
              </div>
              <div class="card-body">
                <form @submit.prevent="sendReview">
                  <div class="form-group text-center">
                    <star-rating star-size="35" active-color="#198754" :show-rating="false" @rating-selected="setRating"></star-rating>
                  </div>
                  <div class="form-group">
                    <label class="info-label d-block mb-2">Quick Suggestions</label>
                    <div class="d-flex flex-wrap" style="gap:6px;">
                      <button type="button" @click="selectSuggestion(rev)" v-for="rev in reviews" :key="rev"
                        class="btn btn-sm btn-outline-secondary" style="font-size:.78rem;">
                        {{ rev }}
                      </button>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="info-label d-block mb-1">Your Comment</label>
                    <textarea required class="form-control" rows="4" v-model="body" placeholder="Tell us more…"></textarea>
                  </div>
                  <button class="btn btn-submit btn-block" type="submit">
                    <i class="fe fe-send mr-1"></i> Submit Review
                  </button>
                </form>
              </div>
            </div>

            <!-- Existing Review Card -->
            <div class="card table-card shadow" v-if="encounterDetails.review != null">
              <div class="d-flex align-items-center px-4 pt-4 pb-3">
                <i class="fe fe-star text-success mr-2"></i>
                <h6 class="mb-0 font-weight-bold">Your Review</h6>
              </div>
              <div class="card-body">
                <div class="text-center mb-3">
                  <star-rating read-only="true" :rating="encounterDetails.rating && encounterDetails.rating.score"
                    star-size="30" active-color="#198754" :show-rating="false"></star-rating>
                </div>
                <p class="text-center" style="font-size:.9rem;">{{ encounterDetails.review && encounterDetails.review.body }}</p>
                <p class="text-muted text-center" style="font-size:.8rem;">
                  {{ encounterDetails.review && encounterDetails.review.created_at | moment("from", "now") }}
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>

    </main>
  </section>
</template>

<script>
import StarRating from "vue-star-rating";

import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading,
    StarRating,
  },
  data() {
    return {
      reviews: [
        "The staff were caring and attentive.",
        "I received prompt and efficient service.",
        "The facility was clean and well-organized.",
        "Everyone from the reception to the nurses was friendly and professional",
        "I felt well cared for during my visit.",
        "I was impressed with how quickly I received my test results.",
        "I experienced long wait times during my visit.",
        "The staff seemed overwhelmed and not very attentive to my needs.",
        "I felt my concerns were dismissed by the doctor.",
        "I left without satisfactory answers.",
        "The facility was dirty",
        "I felt neglected during my visit.",
      ],
      encounterDetails: {
        rating:""
      },
      patient: "",
      rating: null,
      isLoading: false,
      encounterId: "",
      providers: "",
      body: "",
      fullPage: true,
    };
  },

  methods: {
    setRating(rating) {
      this.rating = rating;
    },
    selectSuggestion(rev) {
      this.body = rev;
    },
    getUserEncounterDetails() {
      this.isLoading = true;
      this.axios
        .get(`/api/v1/service_summary/${this.$route.params.id}`)
        .then((response) => {
          this.encounterDetails = response.data;
          console.log(this.encounterDetails);
        })
        .catch((error) => {
          console.error(error);
        });
      this.isLoading = false;
    },

    sendReview() {
      if (this.rating == null) {
        this.$toasted.error("Please Leave a rating", {
          position: "top-center",
          duration: 3000,
        });
      } else {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/comments`, {
            provider_id: this.encounterDetails.provider_id,
            user_id: this.encounterDetails.client_id,
            service_summary_id: this.$route.params.id,
            body: this.body,
            score: this.rating,
          })
          .then((response) => {
            this.isLoading = false;

            console.log(response);
            this.$toasted.info("Review Submitted Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.getUserEncounterDetails();
          })
          .catch((error) => {
            this.isLoading = false;
            console.error(error);
          });
      }
    },
    updateEncounterStatus(ecc, status) {
      if (confirm("Are you Sure?")) {
        this.axios
          .post(`/api/v1/auth/updateEncounterStatus`, {
            id: ecc.id,
            is_confirmed: status,
          })
          .then((response) => {
            this.getUserEncounterDetails();
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
  },

  created() {
    this.getUserEncounterDetails();
  },
};
</script>
